<script setup lang="ts">
import MultiSelect from '@/components/MultiSelect.vue'
import { Checkbox } from '@/foundation/checkbox'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/foundation/form'
import AutoFormLabel from './AutoFormLabel.vue'
import type { FieldProps } from './interface'

type GenericOption = { key: string; label: string; type?: string; options?: any[] }
const props = defineProps<FieldProps>()
const { config, disabled } = props

function getActiveKey(componentField: any): string | null {
  const keys = Object.keys(componentField.modelValue || {})

  return keys.length > 0 ? keys[0] : null
}

function onCheckboxClick(opt: GenericOption, componentField: any) {
  const key = opt.key
  const activeKey = getActiveKey(componentField)

  if (activeKey === key) {
    return
  }

  const currentValue = componentField.modelValue || {}

  if (activeKey && (activeKey === 'teams' || activeKey === 'users')) {
    const currentSelection = currentValue[activeKey]

    if (!Array.isArray(currentSelection) || currentSelection.length === 0) {
      return
    }
  }

  if (opt.type === 'multiselect') {
    componentField['onUpdate:modelValue']({ [key]: [] })
  } else {
    componentField['onUpdate:modelValue']({ [key]: true })
  }
}

function onMultiChange(key: string, items: any[], componentField: any) {
  componentField['onUpdate:modelValue']({ [key]: items })
}
</script>

<template>
  <FormField v-slot="{ componentField }" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel :required="required">
        {{ config?.label }}
      </AutoFormLabel>
      <FormControl>
        <div class="space-y-4">
          <div v-for="opt in config?.inputProps?.options || []" :key="opt.key" class="flex flex-col">
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <Checkbox
                :is-checked="getActiveKey(componentField) === opt.key"
                :disabled="disabled"
                @click="() => onCheckboxClick(opt, componentField)"
              />
              <span>{{ opt.label }}</span>
            </label>
            <div v-if="opt.type === 'multiselect' && getActiveKey(componentField) === opt.key" class="mt-2">
              <MultiSelect
                :options="opt.options || []"
                :value="componentField.modelValue[opt.key]"
                :placeholder="config.inputProps.placeholder"
                :inside-text="config.inputProps.insideText"
                :class="config.inputProps.class"
                :show-icon="config.inputProps.showIcon"
                @update:value="(items) => onMultiChange(opt.key, items, componentField)"
              />
            </div>
          </div>
        </div>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
